import React from "react";
import Helmet from "react-helmet";
import { injectIntl } from "react-intl";

const HelmetIntl = ({ intl, id, ...props }) => (
  <Helmet title={intl.formatMessage({ id })} {...props} />
);

export default injectIntl(HelmetIntl);
